import { WifiInfo } from "@core/ability";

class WifiHandler {
  public static sortWifiListWithRssi(wifiInfoList: WifiInfo[]) {
    return wifiInfoList.sort((a, b) => b.rssi - a.rssi);
  }

  public static filterWifiList(
    wifiInfoList: WifiInfo[],
    filter: keyof WifiInfo = "pinCode"
  ) {
    const filteredList =  wifiInfoList.filter((wifi) => wifi[filter] !== "");
    // 使用 Map 去重：key = deviceName + pinCode
  const seen = new Map<string, Set<string>>();

  return filteredList.filter((wifi) => {
    const { deviceName, pinCode } = wifi;
    
    // 初始化 deviceName 的 Set
    if (!seen.has(deviceName)) {
      seen.set(deviceName, new Set([pinCode]));
      return true;
    }

    // 检查 pinCode 是否重复
    const existingCodes = seen.get(deviceName)!;
    if (!existingCodes.has(pinCode)) {
      existingCodes.add(pinCode);
      return true;
    }

    return false;
  });
  }
}

export default WifiHandler;
